// extracted by mini-css-extract-plugin
module.exports = {"small":"500"};
    if(module.hot) {
      // 1590940330028
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  